import { immer } from "zustand/middleware/immer";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ToastType = "expired" | "inactivity" | "otp_expired" | "revoked" | "password_expired" | "account_closed";

type Store = {
    toasts: Array<ToastType>;
    addToast: (value: ToastType) => void;
    removeToast: (value: ToastType) => void;
};

const uniq = <T>(array: T[]): T[] => Array.from(new Set(array));

const baseStore = immer<Store>((set) => {
    return {
        toasts: [],
        addToast: (value) => {
            set((state) => {
                state.toasts = uniq([...state.toasts, value]);
            });
        },
        removeToast: (value) => {
            set((state) => {
                const index = state.toasts.findIndex((item) => item === value);
                if (index !== -1) {
                    state.toasts.splice(index, 1);
                }
            });
        },
    };
});
export const useAuthToastStore = create(
    persist(baseStore, {
        name: "authToastStore",
    })
);
